import { useAppSelector } from "./redux";

export function useAuth() {
  const user = useAppSelector((state) => state.auth.data?.user ?? null);
  const permissionsSet = new Set(user?.permissions ?? []);
  const permissions = user?.permissions ?? [];
  const userRoles = user?.roles?.map((role) => role.name.toLowerCase()) || [];

  function hasPermission(code: string) {
    return permissionsSet.has(code);
  }

  function hasAnyPermission(codes: string[]) {
    return codes.some(hasPermission);
  }

  function hasAllPermissions(codes: string[]) {
    return codes.every(hasPermission);
  }

  function hasRole(roleName: string) {
    return userRoles.includes(roleName.toLowerCase());
  }

  function hasAnyRole(roleCodes: string[]) {
    return roleCodes.some((roleName) => userRoles.includes(roleName.toLowerCase()));
  }

  function hasAllRoles(roleCodes: string[]) {
    return roleCodes.every((roleName) => userRoles.includes(roleName.toLowerCase()));
  }

  function hasFeature(name: string) {
    return user?.features[name] === true;
  }

  return { 
    user, 
    permissions, 
    hasPermission, 
    hasAnyPermission, 
    hasAllPermissions, 
    hasRole,
    hasAnyRole,
    hasAllRoles,
    hasFeature,
  };
}

